import styled from "styled-components"

import { Bounds, Box } from "../grid"
import { devices } from "../../utils/styleVariables"
import { BaseContainer } from "../container"
import img from "../../images/eid99.svg.png"

const FoldContainer = styled(BaseContainer)``
const FoldSection = styled(Box)``
const FoldText = styled(Bounds)`
  width: 80%;
  margin: 0 auto 40px;
`

const FoldButton = styled.div`
  position: relative;
  width: 100vw;
  text-align: center;
  & .transparent {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: -100%;
    background: linear-gradient(transparent, white);
  }
`

const FoldOverflow = styled.div`
  height: ${props => (props.opened ? "auto" : "320px")};
  overflow: hidden;

  @media ${devices.tablet} {
    height: auto;
  }
`

const IframeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 90vh;
  padding-top: 10vh;
  background: center center / 120% no-repeat url(${img});

  @media ${devices.tablet} {
    background-size: 100%;
  }
  iframe {
    width: 80%;
    height: 80%;
  }
`

export {
  FoldContainer,
  FoldSection,
  FoldText,
  FoldOverflow,
  FoldButton,
  IframeContainer,
}
